import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild} from '@angular/core';
import {DxButtonModule, DxPopupModule, DxScrollViewModule, DxTextBoxModule, DxToastModule} from 'devextreme-angular';
import {CtlTebKurumSinifAramaComponent} from './ctl-teb-kurum-sinif-arama/ctl-teb-kurum-sinif-arama.component';
import {TebKurumSinifService} from './ctl-teb-kurum-sinif.service';
import {CommonModule} from '@angular/common';
import {CtlSablonComponent} from '../ctl-sablon/ctl-sablon.component';
import {LabelMode} from 'devextreme/common';
import {UtilsService} from '../../../services/utils.service';
import {OrtakService} from '../../../services/ortak.service';
import {CtlTemHesapAramaComponent} from "../ctl-tem-hesap/ctl-tem-hesap-arama/ctl-tem-hesap-arama.component";

@Component({
  selector: 'dk-ctl-teb-kurum-sinif',
  templateUrl: './ctl-teb-kurum-sinif.component.html',
  styleUrls: ['./ctl-teb-kurum-sinif.component.scss'],
  standalone: true,
  imports: [
    DxTextBoxModule,
    DxButtonModule,
    CtlTebKurumSinifAramaComponent,
    CommonModule,
    DxPopupModule,
    DxScrollViewModule,
    DxToastModule,
    CtlSablonComponent,
    CtlTemHesapAramaComponent,
  ],
  providers: [TebKurumSinifService],
})
export class CtlTebKurumSinifComponent implements OnInit, OnChanges {
  @ViewChild(CtlSablonComponent) ctlSablonComponent: CtlSablonComponent;
  @Input() labelText = "";
  @Input() labelMode: LabelMode = null;
  @Input() validationRulesMap!: any[];
  @Input() validationV2 = false;
  @Input() setFirstRow = false;
  public crudPopupVisible = false;
  public toastMessage: string;
  public toastVisible = false;
  public showAction = true;
  public title!: string;
  public isFirst = true;
  public control!: any;
  controlName = "TebKurumSinif";
  filterColumn = "KurumsalKod";
  public filterColumnValue: any;
  @Input() isReadOnly = false;
  @Input() isBindCheck = false;
  public data: any;
  @Input() code!: string;
  @Input() period!: number;
  @Input() modul!: string;
  @Input() warningMessage: string | null = null;
  @Output() public dataResult: EventEmitter<any> = new EventEmitter();

  constructor(private service: TebKurumSinifService, private utilsService: UtilsService, private ortakService: OrtakService) {
  }

  ngOnInit(): void {
    if (this.controlName) {
      this.getControl();
    }
    if (!this.period) {
      this.toastMessage = "Lütfen Dönem Bilgisini Kontrol Ediniz.(Teb Kurum Sınıf)"
      this.showAction = false
    }
        this.service.setParams(this.period,this.isReadOnly,this.isBindCheck)

  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['period']) {
      if (this.period == null) this.showAction = false
      else {
        this.showAction = true
        this.service.setParams(this.period,this.isReadOnly,this.isBindCheck)
      }
    }
    if (changes['isReadOnly'] || changes['isBindCheck']) {
        this.service.setParams(this.period,this.isReadOnly,this.isBindCheck)
      }
  }

  getControl() {
    this.ortakService.getControl(this.controlName)
      .subscribe((data) => {
        this.control = data?.controlMetadata;
        //this.service.getDlist(this.control?.dlistCode);
        this.service._gridControlsList.next(data?.controlMetadata.dlistMetadata)
        //if(this.labelText === "")this.labelText = this.control.controlDescription;
        if (data?.controlMetadata.dlistMetadata.baseEntity) {
          if (this.labelText === "") this.labelText = this.control.controlDescription;
          if (this.code && this.control) this.getData(this.code,true)
          if(!this.code && this.setFirstRow) this.getFirstRowAsSelected()
          if (this.isFirst) this.isFirst = false;
        }
      });
  }


  searchClick() {
    if (this.showAction) this.crudPopupVisible = true
    else this.toastVisible = true
  }

  clear() {
    this.title = '';
    this.code = '';
    this.data = null;
    this.filterColumnValue = ''
    this.dataResult.emit(null);
  }

  handleValueChange(e: any) {
    if (this.showAction) {
      if (e === '' || e === null) this.clear();
      else if (!this.isFirst) this.getData(e);
      this.isFirst = false;
    } else this.toastVisible = true
  }

  getData(code: string, isSetData?: boolean) {
    this.data = this.service.getData(code,this.control, this.period, this.control.dlistMetadata.baseEntity,isSetData, this.modul);
    this.data.load().done((result: any) => {
      if (result.length === 1) {
        this.title = result[0].Ad;
        this.code = result[0].KurumsalKod;
        this.dataResult.emit(result[0]);
      }
      if (result.length > 1) {
        if (result[0].KurumsalKod === code) {
          this.title = result[0].Ad;
          this.code = result[0].KurumsalKod;
          this.dataResult.emit(result[0]);
        } else {
          this.filterColumnValue = code;
          this.searchClick();
        }
      }
      if (result.length === 0 && this.code.length > 0) {
        this.utilsService.showError('KurumsalKod Bulunamadı');
        this.clear();
      }

    });

  }

  getFirstRowAsSelected(){

    if(!this.code && this.setFirstRow&& this.control) {
      this.service.getData(null,this.control, this.period, this.control?.dlistMetadata?.baseEntity, null, this.modul).load().then((result: any) => {
        if (result.length > 0) {
          this.title = result[0].Ad;
          this.code = result[0].KurumsalKod;
          this.dataResult.emit(result[0]);
          this.isFirst = true
        }
      })
    }
  }

  closePopupAfter(result: any, sablonCmp: CtlSablonComponent) {
    if (result?.data) {
      this.isFirst=true
      this.data = result.data;
      this.title = result.data.Ad;
      this.code = result.data.KurumsalKod;
      this.dataResult.emit(this.data);
    }
    this.crudPopupVisible = false;
    this.filterColumnValue = ''
    setTimeout(() => {
      sablonCmp.focusInput();
    });
  }
}
